import { Button } from '@/shared/ui/Button'

type QuizzesListEmptyProps = {
  filtered?: boolean
  onClearFilter?: () => void
}

export const QuizzesListEmpty = ({
  filtered,
  onClearFilter
}: QuizzesListEmptyProps) => (
  <div className="py-10 text-center">
    <p className="mb-2 text-2xl" aria-hidden>
      🧠
    </p>
    <p className="mb-2 text-sm font-bold text-gray-800">
      {filtered
        ? 'Nenhum quiz neste filtro'
        : 'Nenhum quiz disponível no momento'}
    </p>
    <p className="mb-4 text-gray-500">
      {filtered
        ? 'Tente outro filtro para ver mais desafios.'
        : 'Novos desafios serão liberados em breve.'}
    </p>
    {filtered && onClearFilter && (
      <Button
        variant="secondary"
        size="sm"
        showTrailingIcon={false}
        onClick={onClearFilter}
      >
        Ver todos
      </Button>
    )}
  </div>
)
